import * as yup from "yup";
import { AnyObject, Maybe } from "yup/lib/types";
import { mobileNumberRegex } from "./phone-numbers";
import { isValid, parse } from "date-fns";

export function extendYup() {
  yup.addMethod<yup.StringSchema>(
    yup.string,
    "mobile",
    function (this, message) {
      return this.test("mobile", message, function (value) {
        if (!value) {
          return true;
        }
        return mobileNumberRegex.test(value?.replace(/\s/g, ""));
      });
    }
  );

  yup.addMethod<yup.StringSchema>(
    yup.string,
    "dateString",
    function (this, message) {
      return this.test("dateString", message, function (value) {
        if (!value) {
          return false;
        }
        const date = parse(value, "dd/MM/yyyy", new Date());
        return isValid(date);
      });
    }
  );
}

declare module "yup" {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
  > extends yup.BaseSchema<TType, TContext, TOut> {
    /** Ensures the string is a valid date in `dd/MM/yyyy` format */
    dateString(message: string): StringSchema<TType, TContext>;
    /** Ensures the string is a valid mobile number, using regex */
    mobile(message: string): StringSchema<TType, TContext>;
  }
}

export default yup;
